import { CulturesDomain } from 'core/typing/domains/CulturesDomain/CulturesDomain';
import { createEvent } from 'effector';

export const loadCultures = createEvent('loadCultures');
export const loadCulturesDone = createEvent<CulturesDomain>('loadCulturesDone');
export const loadCulturesFail = createEvent('loadCulturesFail');
